// src/views/Settings/LegacyAccountRedirect.jsx
//
// Las rutas viejas del dinero —/user/wallet, /user/coins, /user/subscriptions—
// no pueden ser un <Navigate> a secas: el destino lleva el id de la cuenta, que
// solo se conoce en runtime, y `/user/coins` vuelve de Tilopay con `?order=`,
// que hay que arrastrar o la compra no se confirma.
//
// `/user/coins` se mantiene vivo para siempre por eso mismo: un pago iniciado
// antes de este cambio sigue volviendo ahí, y tiene que aterrizar bien.
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useOrganization } from '../../contexts/OrganizationContext';
import Loading from '../../components/Loading/Loading';

// Tope de espera a que la cuenta se resuelva. Sin él, una cuenta que nunca llega
// deja un spinner que no puede terminar — se prefiere el inicio, que al menos
// es accionable.
const ACCOUNT_TIMEOUT_MS = 5000;

export default function LegacyAccountRedirect({ section = 'billing', tab }) {
  const { currentAccount } = useOrganization();
  const location = useLocation();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (currentAccount?.id) return undefined;
    const timer = setTimeout(() => setTimedOut(true), ACCOUNT_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [currentAccount?.id]);

  if (!currentAccount?.id) {
    return timedOut ? <Navigate to="/" replace /> : <Loading />;
  }

  const params = new URLSearchParams(location.search);
  if (tab) params.set('tab', tab);
  const query = params.toString();

  return (
    <Navigate
      to={`/a/${currentAccount.id}/${section}${query ? `?${query}` : ''}`}
      replace
    />
  );
}
